export default __webpack_public_path__ + "static/media/product.bc62f425.png";